import React from 'react';

function FieldTemplate(props) {
  const { children } = props;

  return <>{children}</>;
}

export default FieldTemplate;
